import { forwardRef, useImperativeHandle } from 'react';
import { ContactOrPurposeSectionCoCo } from '../shared/ContactOrPurposeSectionCoCo.js';
import type { ConfigHandle, ProductConfigProps } from '../productConfigTypesCoCo.js';

/**
 * Configuration for quantity based accessories: purpose of use, cost center and reference only —
 * accessories are not assigned to a user. The registry marks this config as product scoped, so
 * checkout renders it once per product regardless of the ordered quantity and applies the values
 * to every ordered unit through `accessorySharedUnitKeys`.
 */
export const AccessoryProductConfigCoCo = forwardRef<ConfigHandle, ProductConfigProps>(
  ({ basketItem, orderItem, schema, contactFormRefs, contactsUpdateMethods, accessorySharedUnitKeys }, ref) => {
    const cartItemInstanceId = `${basketItem.id}-${orderItem.basketItemIndex}`;

    // No inner form — the contact form ref collected in ProductsStepCoCo handles validation.
    useImperativeHandle(
      ref,
      () => ({
        validate: async () => true,
        scrollToFirstError: () => {},
        getErrorCount: () => 0,
      }),
      []
    );

    return (
      <div id={`accessory-config-${cartItemInstanceId}`}>
        <ContactOrPurposeSectionCoCo
          schema={schema}
          orderItem={orderItem}
          contactFormRefs={contactFormRefs}
          contactsUpdateMethods={contactsUpdateMethods}
          isMandatory={false}
          showAccordion={false}
          showUserContact={false}
          showPurposeOfUse={true}
          accessorySharedUnitKeys={accessorySharedUnitKeys}
        />
      </div>
    );
  }
);

AccessoryProductConfigCoCo.displayName = 'AccessoryProductConfigCoCo';
